import {
    INCIDENCE_CATEGORY,
    INCIDENCE_CATEGORY_ERROR,
} from "_models/redux/types";

const initialState = {
    incidenceCategoryObj: [],
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case INCIDENCE_CATEGORY:
            return {
                ...state,
                incidenceCategoryObj: action.payload,
                loading: true,
            };

        case INCIDENCE_CATEGORY_ERROR:
            return {
                ...state,
                incidenceCategoryObj: action.payload,
                loading: false,
            };
        default:
            return state;
    }
}
